export default {
  SET_OVERALL_LIST_TABLE(state, data) {
    state.all_overall_list_table = data
  },
  SET_ALL_CLIENTS_BY_INCOME(state, data) {
    state.all_clients_by_income = data
  },
  SET_ALL_CLIENTS_TABLE(state, data) {
    state.all_clients_table = data
  },
  SET_NOT_SOLD_FLAT(state, data) {
    state.not_sold_flat = data
  },
  SET_SOLD_FLAT(state, data) {
    state.sold_flat = data
  },
  SET_OVERALL_TABLE(state, data) {
    state.overall_table = data
  },
  SET_OBJECTS(state, data) {
    state.objects = data
  },
  SET_ONE_OBJECT(state, data) {
    state.single_object = data
  },
  SET_OBJECT_TYPES(state, data) {
    state.object_types = data
  },
  SET_OBJECT_INFRASTURCTURES(state, data) {
    state.object_infrastuctures = data
  },
  SET_PARKING_OPTIONS(state, data) {
    state.parking_options = data
  },
  SET_OBJECT_CALCULATIONS(state, data) {
    state.object_calculations = data
  },
  SET_CONSTRUCTION_PROGRESS(state, data) {
    state.construction_progress = data
  },
  SET_OBJECT_PRICE_HISTORY(state, data) {
    state.price_history = data
  },
  SET_OBJECT_DISCOUNT_HISTORY(state, data) {
    state.discount_history = data
  },
  SET_PAYMENT_TYPES(state, data) {
    state.payment_types = data
  },
  SET_ONE_PAYMENT_TYPE(state, data) {
    state.single_payment_type = data
  },
  SET_REPORTS(state, data) {
    state.reports = data
  },
  SET_RELATED_PERSON(state, data) {
    state.relatedPerson = data
  },
}
